import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { NavigationComponent } from 'navigation';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  imports: [RouterOutlet, NavigationComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthComponent {
  private route = inject(ActivatedRoute);
  isNativeApp = false;

  constructor() {
    const route = this.route;

    route.queryParams.subscribe(params => {
      if (params['app_setup'] === 'true') this.isNativeApp = true;

      if (params['redirectSearch']) {
        try {
          const redirectSearch = JSON.parse(params['redirectSearch']);
          if (redirectSearch.app_setup !== undefined) this.isNativeApp = redirectSearch.app_setup;
        } catch {
          console.warn('Invalid redirectSearch parameter');
        }
      }

      try {
        if (localStorage.getItem('isApp') === 'true') this.isNativeApp = true;
      } catch {
        console.warn('localStorage is not available');
      }
    });
  }
}
